<template>
  <div class="dialog-body">
    <el-dialog :title="this.title" :visible.sync="dialogVisible" append-to-body width="50%">
      <div class="result">
        <el-row :gutter="24">
          <el-col :span="24">
            <span style="text-align: center; display: block">{{ this.message }}</span>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: 'CommonTextDialog',
    data() {
      return {
        dialogVisible: false,
        title: '',
        message: '',
      };
    },
    methods: {
      openDialog(title = '', message = '') {
        this.dialogVisible = true;
        this.title = title;
        this.message = message;
      },
      handleClose() {
        this.dialogVisible = false;
        this.title = '';
        this.message = '';
      },
    },
  };
</script>

<style scoped>
  .el-dialog .el-dialog__body {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .dialog-body {
    display: flex;
    justify-content: center;
    flex-direction: column;
  }

  .result {
    padding: 20px 100px 20px 100px;
  }

  ::v-deep .el-dialog__footer {
    text-align: center;
  }
</style>
